// Frontend module registry — mirrors backend routes/menu.py.
// id + route + permissionKey + defaultLabel are IMMUTABLE (code-controlled).
// display_label / parent_gid / sort_order come from server config and can
// be user-customized via System Settings → Menü Düzeni.
import {
  LayoutDashboard, Users2, Truck, Boxes, Warehouse, ShoppingCart, ClipboardList,
  Factory, ShieldCheck, ShieldAlert, PackageCheck, BarChart3, FileText,
  UserCog, Settings, Route as RouteIcon, Receipt, Sparkles, MessageSquare,
  StickyNote, PlugZap, Gift, FlaskConical, Home, Beaker, Users, HandCoins,
  Search, Wrench, Package, ScrollText, Archive,
} from "lucide-react";

// Stable module registry. Order here is used as fallback if the server
// registry cannot be loaded.
// CustomerERP Faz 0 — MetaERP modül kayıtları yalnız REFERANS (menüde kullanılmaz).
export const LEGACY_METAERP_MODULE_REGISTRY = [
  { id: "dashboard",         to: "/",                  defaultLabel: "Kontrol Paneli",       permKey: "dashboard",         defaultGroup: "genel",         icon: LayoutDashboard, accent: "rose"    },
  { id: "user_dashboard",    to: "/user-control-dashboard", defaultLabel: "Kullanıcı Kontrol Paneli", permKey: "user_control_dashboard", defaultGroup: "genel",         icon: LayoutDashboard, accent: "indigo"  },
  { id: "kpi_portal",        to: "/kpi-portal",        defaultLabel: "Yönetim Paneli",       permKey: "kpi_portal",        defaultGroup: "genel",         icon: BarChart3,       accent: "indigo"  },
  { id: "customer_service",  to: "/customer-service",  defaultLabel: "Müşteri Hizmetleri",   permKey: "customer_service",  defaultGroup: "genel",         icon: MessageSquare,   accent: "rose"    },
  { id: "meetings",          to: "/meetings",          defaultLabel: "Toplantı Notları",     permKey: "meetings",          defaultGroup: "genel",         icon: StickyNote,      accent: "amber"   },
  { id: "requests",          to: "/requests",          defaultLabel: "Talepler / Bildirimler", permKey: "requests",        defaultGroup: "genel",         icon: FileText,        accent: "amber"   },
  { id: "rd",                to: "/rd",                defaultLabel: "Ar-Ge Portalı",        permKey: "rd",                defaultGroup: "arge",          icon: FlaskConical,    accent: "violet"  },
  { id: "formulas",          to: "/formulas",          defaultLabel: "Formüller",             permKey: "formulas",          defaultGroup: "arge",          icon: Beaker,          accent: "violet"  },
  { id: "quotations",        to: "/quotations",        defaultLabel: "Fiyat Teklifleri",     permKey: "quotations",        defaultGroup: "arge",          icon: Receipt,         accent: "pink"    },
  { id: "proforma",          to: "/proformas",         defaultLabel: "Proforma Fatura",      permKey: "proforma",          defaultGroup: "arge",          icon: Receipt,         accent: "pink"    },
  { id: "catalog",           to: "/catalog",           defaultLabel: "Katalog",              permKey: null,                defaultGroup: "arge",          icon: Package,         accent: "amber"   },
  { id: "inventory",         to: "/inventory",         defaultLabel: "Envanter Yönetimi",    permKey: "inventory",         defaultGroup: "uretim",        icon: Boxes,           accent: "teal"    },
  { id: "purchasing",        to: "/purchasing",        defaultLabel: "Satın Alma",           permKey: "purchasing",        defaultGroup: "uretim",        icon: ShoppingCart,    accent: "amber"   },
  { id: "sales_orders",      to: "/sales-orders",      defaultLabel: "Satış Siparişleri",    permKey: "sales_orders",      defaultGroup: "uretim",        icon: ClipboardList,   accent: "emerald" },
  { id: "production",        to: "/production",        defaultLabel: "Üretim Emirleri",      permKey: "production",        defaultGroup: "uretim",        icon: Factory,         accent: "orange"  },
  { id: "quality",           to: "/quality",           defaultLabel: "Kalite Kontrol",       permKey: "quality",           defaultGroup: "uretim",        icon: ShieldCheck,     accent: "cyan"    },
  { id: "quarantine",        to: "/quarantine",        defaultLabel: "Karantina",             permKey: "quarantine",        defaultGroup: "uretim",        icon: ShieldAlert,     accent: "amber"   },
  { id: "finished_products", to: "/finished-products", defaultLabel: "Bitmiş Ürünler",       permKey: "finished_products", defaultGroup: "uretim",        icon: PackageCheck,    accent: "lime"    },
  { id: "gmp",               to: "/gmp",               defaultLabel: "GMP Portalı",           permKey: "gmp",               defaultGroup: "gmp_kalite",    icon: Sparkles,        accent: "emerald" },
  { id: "trainings",         to: "/trainings",         defaultLabel: "Eğitim Yönetimi",      permKey: "personnel",         defaultGroup: "gmp_kalite",    icon: UserCog,         accent: "violet"  },
  { id: "recalls",           to: "/recalls",           defaultLabel: "Geri Çağırma",         permKey: "recalls",           defaultGroup: "gmp_kalite",    icon: ShieldAlert,     accent: "rose"    },
  { id: "traceability",      to: "/traceability",      defaultLabel: "İzlenebilirlik",       permKey: "traceability",      defaultGroup: "gmp_kalite",    icon: RouteIcon,       accent: "fuchsia" },
  { id: "finance",           to: "/finance",           defaultLabel: "Muhasebe",              permKey: "finance",           defaultGroup: "muhasebe",      icon: HandCoins,       accent: "emerald" },
  { id: "monthly_reports",   to: "/monthly-reports",   defaultLabel: "Aylık Muhasebe Raporu", permKey: "finance",           defaultGroup: "muhasebe",      icon: FileText,        accent: "indigo"  },
  { id: "customers",         to: "/customers",         defaultLabel: "Müşteriler",           permKey: "customers",         defaultGroup: "is_ortaklari",  icon: Users2,          accent: "sky"     },
  { id: "suppliers",         to: "/suppliers",         defaultLabel: "Tedarikçiler",         permKey: "suppliers",         defaultGroup: "is_ortaklari",  icon: Warehouse,       accent: "amber"   },
  { id: "regulatory",        to: "/regulatory",        defaultLabel: "Regülasyon & İhracat", permKey: "regulatory",        defaultGroup: "arastirma",     icon: ShieldCheck,     accent: "violet"  },
  { id: "supports",          to: "/supports",          defaultLabel: "Destekler",             permKey: null,                defaultGroup: "arastirma",     icon: Gift,            accent: "emerald" },
  { id: "users",             to: "/users",             defaultLabel: "Kullanıcılar",         permKey: "users",             defaultGroup: "ayarlar",       icon: Users,           accent: "sky"     },
  { id: "integrations",      to: "/integrations",      defaultLabel: "Entegrasyonlar",       permKey: "integrations",      defaultGroup: "ayarlar",       icon: PlugZap,         accent: "fuchsia" },
  { id: "settings",          to: "/settings",          defaultLabel: "Sistem Ayarları",      permKey: "settings",          defaultGroup: "ayarlar",       icon: Settings,        accent: "slate"   },
  { id: "personnel",         to: "/personnel",         defaultLabel: "Personel Takip",       permKey: "personnel",         defaultGroup: "ayarlar",       icon: UserCog,         accent: "violet"  },
];

export const LEGACY_METAERP_GROUPS = [
  { gid: "genel",        defaultLabel: "GENEL",        icon: Home,        sortOrder: 0 },
  { gid: "arge",         defaultLabel: "AR-GE",        icon: FlaskConical, sortOrder: 1 },
  { gid: "uretim",       defaultLabel: "ÜRETİM",       icon: Factory,     sortOrder: 2 },
  { gid: "gmp_kalite",   defaultLabel: "GMP & KALİTE", icon: Sparkles,    sortOrder: 3 },
  { gid: "muhasebe",     defaultLabel: "MUHASEBE",     icon: HandCoins,   sortOrder: 4 },
  { gid: "is_ortaklari", defaultLabel: "İŞ ORTAKLARI", icon: Users2,      sortOrder: 5 },
  { gid: "arastirma",    defaultLabel: "ARAŞTIRMA",    icon: Search,      sortOrder: 6 },
  { gid: "ayarlar",      defaultLabel: "AYARLAR",      icon: Wrench,      sortOrder: 7 },
];

// CustomerERP Faz 0 — görünür menü (backend routes/menu.py ile aynı).
export const MODULE_REGISTRY = [
  { id: "dashboard", to: "/",          defaultLabel: "Kontrol Paneli",          permKey: "dashboard", defaultGroup: "genel",   icon: LayoutDashboard, accent: "rose"   },
  { id: "customers", to: "/customers", defaultLabel: "Müşteriler",              permKey: "customers", defaultGroup: "is_ortaklari", icon: Users2, accent: "sky" },
  { id: "suppliers", to: "/suppliers", defaultLabel: "Tedarikçiler",            permKey: "suppliers", defaultGroup: "is_ortaklari", icon: Warehouse, accent: "amber" },
  { id: "customer_service", to: "/customer-service", defaultLabel: "Müşteri Hizmetleri", permKey: "customer_service", defaultGroup: "diger", icon: MessageSquare, accent: "rose" },
  { id: "requests",  to: "/requests",  defaultLabel: "Talepler",                permKey: "requests",  defaultGroup: "diger", icon: FileText, accent: "amber" },
  { id: "catalog",   to: "/catalog",   defaultLabel: "Katalog",                 permKey: null,        defaultGroup: "diger", icon: Package, accent: "amber" },
  { id: "supports",  to: "/supports",  defaultLabel: "Destekler",               permKey: null,        defaultGroup: "diger", icon: Gift, accent: "emerald" },
  { id: "personnel", to: "/personnel", defaultLabel: "Personel Takip",          permKey: "personnel", defaultGroup: "diger", icon: UserCog, accent: "violet" },
  { id: "monthly_reports", to: "/monthly-reports", defaultLabel: "Aylık Muhasebe Raporu", permKey: "finance", defaultGroup: "diger", icon: FileText, accent: "indigo" },
  { id: "finance", to: "/finance", defaultLabel: "Muhasebe", permKey: "finance", defaultGroup: "muhasebe", icon: HandCoins, accent: "emerald" },
  { id: "sales_orders", to: "/sales-orders", defaultLabel: "Satış Siparişleri", permKey: "sales_orders", defaultGroup: "satis", icon: ShoppingCart, accent: "emerald" },
  { id: "purchasing", to: "/purchasing", defaultLabel: "Satın Alma", permKey: "purchasing", defaultGroup: "satin_alma", icon: Truck, accent: "amber" },
  { id: "shipping", to: "/shipping", defaultLabel: "Sevkiyat", permKey: "shipments", defaultGroup: "sevkiyat", icon: Truck, accent: "teal" },
  { id: "traceability", to: "/traceability", defaultLabel: "İzlenebilirlik", permKey: "traceability", defaultGroup: "sevkiyat", icon: RouteIcon, accent: "fuchsia", adminOnly: true },
  { id: "products",  to: "/products",  defaultLabel: "Ürünler",                 permKey: "products",  defaultGroup: "stok_urunler", icon: Package, accent: "amber" },
  { id: "stock",     to: "/stock",     defaultLabel: "Stok",                    permKey: "inventory", defaultGroup: "stok_urunler", icon: Boxes, accent: "teal" },
  { id: "material_stock", to: "/material-stock", defaultLabel: "Malzeme Stok", permKey: "inventory", defaultGroup: "stok_urunler", icon: Package, accent: "fuchsia" },
  { id: "users",     to: "/users",     defaultLabel: "Kullanıcılar & Yetkiler", permKey: "users",     defaultGroup: "yonetim", icon: Users,           accent: "sky"    },
  { id: "settings",  to: "/settings",  defaultLabel: "Sistem Ayarları",         permKey: "settings",  defaultGroup: "yonetim", icon: Settings,        accent: "slate"  },
  { id: "audit_log", to: "/audit-log", defaultLabel: "Audit Log",               permKey: "admin_only", defaultGroup: "yonetim", icon: ScrollText,      accent: "indigo" },
  { id: "backup",    to: "/backup",    defaultLabel: "Yedekleme",               permKey: "admin_only", defaultGroup: "yonetim", icon: Archive,         accent: "teal"   },
];

export const DEFAULT_GROUPS = [
  { gid: "genel",   defaultLabel: "GENEL",   icon: Home,   sortOrder: 0 },
  { gid: "is_ortaklari", defaultLabel: "İŞ ORTAKLARI", icon: Users2, sortOrder: 1 },
  { gid: "satis", defaultLabel: "SATIŞ", icon: ShoppingCart, sortOrder: 2 },
  { gid: "satin_alma", defaultLabel: "SATIN ALMA", icon: Truck, sortOrder: 3 },
  { gid: "sevkiyat", defaultLabel: "SEVKİYAT", icon: Truck, sortOrder: 4 },
  { gid: "stok_urunler", defaultLabel: "STOK & ÜRÜNLER", icon: Boxes, sortOrder: 5 },
  { gid: "muhasebe", defaultLabel: "MUHASEBE", icon: HandCoins, sortOrder: 6 },
  { gid: "diger", defaultLabel: "DİĞER MODÜLLER", icon: Sparkles, sortOrder: 7 },
  { gid: "yonetim", defaultLabel: "YÖNETİM", icon: Wrench, sortOrder: 8 },
];

// Sentinel pseudo-group for top-level (ungrouped) items. Frontend renders
// its items directly at the sidebar root with no group header. Backend
// validates this gid explicitly.
export const TOP_LEVEL_GID = "__top__";

const REGISTRY_INDEX = new Map(MODULE_REGISTRY.map(m => [m.id, m]));

// Convert stored server config → an ordered [group, items[]] structure for
// rendering. Applies fail-safes: unknown ids dropped, missing items placed
// under their default_group, invalid gids fall back to defaults.
export function assembleNav(config) {
  const cfg = config && config.groups && config.items ? config : null;
  const groupMap = new Map(DEFAULT_GROUPS.map(g => [g.gid, {
    gid: g.gid, displayLabel: g.defaultLabel, sortOrder: g.sortOrder, icon: g.icon,
  }]));
  // Reserve the top-level pseudo-group so items with parent_gid="__top__"
  // resolve to a valid bucket. It's always ordered first and rendered
  // without a group header.
  groupMap.set(TOP_LEVEL_GID, {
    gid: TOP_LEVEL_GID, displayLabel: "", sortOrder: -1,
    icon: null, isTopLevel: true,
  });
  if (cfg) {
    for (const g of cfg.groups) {
      if (!groupMap.has(g.gid)) continue; // unknown → drop
      const base = groupMap.get(g.gid);
      groupMap.set(g.gid, {
        ...base,
        displayLabel: g.display_label || base.displayLabel,
        sortOrder: typeof g.sort_order === "number" ? g.sort_order : base.sortOrder,
      });
    }
  }
  const groups = Array.from(groupMap.values()).sort((a, b) => a.sortOrder - b.sortOrder);

  // Build items per gid
  const itemsByGid = new Map(groups.map(g => [g.gid, []]));
  const seenIds = new Set();

  if (cfg) {
    for (const it of cfg.items) {
      if (seenIds.has(it.id)) continue;
      const reg = REGISTRY_INDEX.get(it.id);
      if (!reg) continue; // unknown module → silently drop
      const targetGid = itemsByGid.has(it.parent_gid) ? it.parent_gid : reg.defaultGroup;
      const bucket = itemsByGid.get(targetGid) || itemsByGid.get("genel");
      bucket.push({
        ...reg,
        displayLabel: (it.display_label || reg.defaultLabel),
        sortOrder: typeof it.sort_order === "number" ? it.sort_order : bucket.length,
        parentGid: targetGid,
      });
      seenIds.add(it.id);
    }
  }
  // Future-safe: any registry module missing from cfg → placed in default_group
  for (const m of MODULE_REGISTRY) {
    if (seenIds.has(m.id)) continue;
    const bucket = itemsByGid.get(m.defaultGroup) || itemsByGid.get("genel");
    bucket.push({
      ...m, displayLabel: m.defaultLabel,
      sortOrder: bucket.length + 10000,
      parentGid: m.defaultGroup,
    });
  }
  // Sort items within each group
  for (const arr of itemsByGid.values()) {
    arr.sort((a, b) => a.sortOrder - b.sortOrder);
  }
  return groups.map(g => ({ ...g, items: itemsByGid.get(g.gid) || [] }));
}

export function findParentGidForRoute(assembled, pathname) {
  for (const g of assembled) {
    for (const it of g.items) {
      if (it.to === "/" && pathname === "/") return g.gid;
      if (it.to !== "/" && pathname.startsWith(it.to)) return g.gid;
    }
  }
  return null;
}

// Apply user-scoped preferences on top of the assembled (global) nav.
// prefs = {
//   hidden_ids: [id...],
//   item_order: {gid: [id...]},
//   custom_parent: {itemId: gid}  // per-user cross-group placement
// }
// - custom_parent moves items to a different (user-visible) group without
//   touching routes / permissions / IDs (backend enforces same guarantees).
// - Hidden ids are filtered out.
// - Each group's items are ordered by item_order[gid]; ids not listed
//   keep their existing relative order at the end.
export function applyUserPrefs(assembled, prefs) {
  if (!prefs) return assembled;
  const hidden = new Set(prefs.hidden_ids || []);
  const orderMap = prefs.item_order || {};
  const customParent = prefs.custom_parent || {};

  // 1) Flatten all items with their (possibly overridden) target gid.
  const validGids = new Set(assembled.map((g) => g.gid));
  const relocated = new Map();   // gid → items[]
  for (const g of assembled) {
    for (const it of g.items) {
      if (hidden.has(it.id)) continue;
      let targetGid = customParent[it.id];
      if (!targetGid || !validGids.has(targetGid)) targetGid = g.gid;
      const clone = { ...it, parentGid: targetGid };
      if (!relocated.has(targetGid)) relocated.set(targetGid, []);
      relocated.get(targetGid).push(clone);
    }
  }

  // 2) Rebuild each group with relocated items + apply per-group ordering.
  return assembled.map((g) => {
    let items = relocated.get(g.gid) || [];
    const order = orderMap[g.gid];
    if (Array.isArray(order) && order.length) {
      const idx = new Map(order.map((id, i) => [id, i]));
      items = [...items].sort((a, b) => {
        const ai = idx.has(a.id) ? idx.get(a.id) : 10000 + items.indexOf(a);
        const bi = idx.has(b.id) ? idx.get(b.id) : 10000 + items.indexOf(b);
        return ai - bi;
      });
    }
    return { ...g, items };
  });
}

// Convert assembled nav back to a config payload (for saving).
export function toConfigPayload(assembled) {
  const groups = assembled.map((g, i) => ({
    gid: g.gid, display_label: g.displayLabel, sort_order: i,
  }));
  const items = [];
  assembled.forEach((g) => {
    g.items.forEach((it, j) => {
      items.push({
        id: it.id, parent_gid: g.gid,
        display_label: it.displayLabel, sort_order: j,
      });
    });
  });
  return { groups, items };
}

export function defaultAssembled() {
  return assembleNav(null);
}
